module.exports = __webpack_public_path__ + "img/xihuan.7ad8b3e0.png";